import { Box } from "@mui/material";
import React from "react";
import HistoryCard from "./HistoryCard";

export default function ClubHistory() {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        paddingX: "8px",
      }}
    >
      <HistoryCard status="received" />
      <HistoryCard status="send" />
      <HistoryCard status="send" />
      <HistoryCard status="received" />
      <HistoryCard status="received" />
      <HistoryCard status="received" />
      <HistoryCard status="send" />
    </Box>
  );
}
